import { render, staticRenderFns } from "./ElementTask.vue?vue&type=template&id=de439570"
import script from "./ElementTask.vue?vue&type=script&lang=js"
export * from "./ElementTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports